// extracted by mini-css-extract-plugin
export var activityContainer = "_ks-0";
export var typingIndicatorContainer = "_ks-1";
export var typingIndicatorDot = "_ks-2";
export var wave = "_ks-3";